export default __webpack_public_path__ + "assets/qr-code.4fc461dc.png";